import { CommonModule, LocationStrategy, DatePipe, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule     } from './app-routing.module';
import { AuthenticationModule } from './components/authentication/authentication.module';

import { FullComponent  } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

import { AppComponent } from './app.component';
import { ComponentLoaderComponent } from './components/dynamic/component-loader/component-loader.component';

import { environment } from '../environments/environment';

import { DYNAMIC_ENVIRONMENT } from 'ngx-http-env';
import { AuthModule, AuthInterceptor, AuthConfig, AuthService } from '@tempton/ngx-msal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import {
  NotificationComponent,
  ToastComponent,
  SidebarComponent,
  SidebarUserPreferencesTogglerComponent,
  SidebarItemComponent,
  ApplicationSwitcherComponent,
  CountersCardsComponent,
  MobileHeaderMenuComponent,
} from '@shared/components';

import { ApplicationSwitcherMobileComponent } from '@shared/components/dynamic';
import {
  BulkMessagesListComponent,
  BulkMessagesNewComponent,
  BulkMessagesComponent,
  ChatBoxComponent,
  ChatBoxHeaderComponent,
  ChatBoxMessageComponent,
  ChatTypingComponent,
  ChatComponent,
  ChatBadgeComponent,
  ChatRecentComponent,
  ChatTabsComponent,
  ChatsListComponent,
  ChatsListItem
} from '@shared/components/chat';

import {
  UserService,
  NotificationService,
  ToasterService,
  ValidationService,
  LoggingService,
  SessionStorageService,
  QueryCollectorService,
  ActivityReportsCountersService,
  AssignmentsCountersService,
  PhotoDocumentsCountersService,
  VacationRequestsCountersService,
  MileageMoneyCountersService,
  BannersService,
  SidebarStorageService,
  ActivityReportsService,
  HolidaysService,
  PhotoDocumentService,
  AssignmentService,
  AutoReloadService,
  InvoicesService,
  InvoicesCountersService,
  DocumentTypesService,
  AppAccessService,
  ReleasesService,
  FailedErpService,
  CountersService,
  InfoStatesCollectorService,
  ExternalEmployeesService,
  CustomersCompaniesService,
  ReferralsCountersService,
  ContractExtensionsCountersService,
  ExternalEmployeesCountersService,
  PillsService,
  HelperService,
} from '@shared/services';

import {
  DefaultHeadersInterceptor,
  BaseUrlInterceptor,
  ErrorsInterceptor,
  StopBetaCallsInterceptor
} from '@shared/helpers';

import {
  ToggleSidebarDirective,
} from '@shared/directives';
import {SharedModule} from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    BlankComponent,
    NotificationComponent,
    ToastComponent,
    ComponentLoaderComponent,
    FullComponent,
    SidebarComponent,
    SidebarItemComponent,
    SidebarUserPreferencesTogglerComponent,
    ApplicationSwitcherComponent,
    ApplicationSwitcherMobileComponent,
    CountersCardsComponent,
    MobileHeaderMenuComponent,
    ToggleSidebarDirective,
    ChatComponent,
    ChatBadgeComponent,
    ChatRecentComponent,
    ChatTabsComponent,
    ChatBoxComponent,
    ChatBoxHeaderComponent,
    ChatBoxMessageComponent,
    ChatTypingComponent,
    ChatsListComponent,
    ChatsListItem,
    BulkMessagesListComponent,
    BulkMessagesNewComponent,
    BulkMessagesComponent,
    ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    AuthModule,
    ReactiveFormsModule,
    AuthenticationModule,
    SharedModule,
    InfiniteScrollModule
  ],
  providers: [
    {
      provide: AuthConfig,
      useFactory: (): AuthConfig => environment.temptonNgxMsal,
      deps: [DYNAMIC_ENVIRONMENT],
    },
    DatePipe,
    InvoicesService,
    ReleasesService,
    ActivityReportsService,
    CountersService,

    InvoicesCountersService,
    ActivityReportsCountersService,
    AssignmentsCountersService,
    PhotoDocumentsCountersService,
    VacationRequestsCountersService,
    MileageMoneyCountersService,
    ReferralsCountersService,
    ContractExtensionsCountersService,
    ExternalEmployeesCountersService,

    BannersService,
    LoggingService,
    SidebarStorageService,
    NotificationService,
    SessionStorageService,
    QueryCollectorService,
    UserService,
    ToasterService,
    ValidationService,
    HolidaysService,
    DocumentTypesService,
    PhotoDocumentService,
    AssignmentService,
    ExternalEmployeesService,
    CustomersCompaniesService,
    AutoReloadService,
    AppAccessService,
    FailedErpService,
    InfoStatesCollectorService,
    PillsService,
    HelperService,
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor,        multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor,           multi: true, deps: [AuthService] },
    { provide: HTTP_INTERCEPTORS, useClass: DefaultHeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor,         multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: StopBetaCallsInterceptor,  multi: true },
    { provide: LocationStrategy,  useClass: PathLocationStrategy },
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    // [mfa] Redirect user from /#/... to /... to continue supporting urls for hash based routing
    if(window.location.href.match('/\/#\//'))
      window.location.href = window.location.href.replace(/\/#\//, '/')
  }
}
